<template>
  <NuxtLink :to="`/${locale}`" class="logo">
    <LogoMark />
  </NuxtLink>
</template>

<script setup lang="ts">
const { locale } = useI18n()
</script>

<style scoped>
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}
</style>
